module.exports = __webpack_public_path__ + "img/zil.8a807349.svg";